import { prettifyKey } from "v2/utils/prettifyKey";
import { renderReviewValue } from "v2/utils/renderReviewValue";

type KeyValueListProps = {
  value: unknown;
  labels?: Record<string, string>;
};

// Render an object value (e.g. one officer) as readable "Label: value" rows.
export const KeyValueList = ({ value, labels }: KeyValueListProps) => {
  if (!value || typeof value !== "object" || Array.isArray(value)) {
    return <span className="t-text-text-100">{renderReviewValue(value)}</span>;
  }
  const entries = Object.entries(value as Record<string, unknown>).filter(
    ([, v]) => v !== null && v !== undefined && v !== ""
  );
  if (!entries.length) return <span className="t-text-text-100">—</span>;
  return (
    <div className="t-flex t-flex-col t-gap-0.5">
      {entries.map(([k, v]) => (
        <div key={k} className="t-flex t-gap-1.5 t-text-body-sm">
          <span className="t-text-neutral-50">
            {labels?.[k] ?? prettifyKey(k)}:
          </span>
          <span className="t-text-text-100">{renderReviewValue(v)}</span>
        </div>
      ))}
    </div>
  );
};
